import ApplicationController from '../application_controller'

export default class extends ApplicationController {

	static targets = [
		'sessionCompletedOn',
		'formSubmit'
	]

	connect() {
		this.updateSessionCount()
	}

	updateSessionCount(_event) {
		const numberOfDays = this.sessionCompletedOnTarget.value.split(', ').length

		if (numberOfDays == 1) {
			if ('isEditingSession' in this.formSubmitTarget.dataset) {
				this.formSubmitTarget.innerHTML = '<div class="fa fal fa-save"></div>Save Changes'
			} else {
				this.formSubmitTarget.innerHTML = '<div class="fa fal fa-save"></div>Create New Session'
			}
		} else {
			this.formSubmitTarget.innerHTML = `<div class="fa fal fa-rectangle-vertical-history"></div>Create ${numberOfDays} New Sessions`
		}
	}
}

